<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FFFF99">
        <v-card-title>
          <v-icon large left>mdi-excavator</v-icon>
          <h6>Obra - Recepciones de materiales en Obra con remitos de ICSSA</h6>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="6" sm="10" md="6">
              <v-combobox
                dense
                v-model="comboobra"
                :items="obras"
                item-text="nombre"
                item-value="gasto"
                label="Obras"
                @change="cargarListado"
              ></v-combobox>
            </v-col>
            <v-col cols="6" sm="2" md="6">
              <v-switch
                v-model="obrasactivas"
                :label="'Sólo Obras activas'"
                @change="cargarObras(obrasactivas)"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-data-table
        dense
        :headers="headers"
        :items="listadoremitos"
        locale="es-ar"
        class="elevation-1"
        fixed-header
        :items-per-page="20"
        :footer-props="{
          itemsPerPageText: 'Remitos por página',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                color="blue"
                class="mr-2"
                @click.stop="verInforme(item)"
                v-on="on"
                v-bind="attrs"
              >
                mdi-eye
              </v-icon>
            </template>
            <span>Ver Remito</span>
          </v-tooltip>
          <v-icon
            small
            color="purple"
            class="mr-2"
            @click="cargarRemito(item, 'REMITO INTERNO', '2')"
          >
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
      <VerInforme
        :visible="showInforme"
        :codigo="editedItem.codgral"
        @close="showInforme = false"
      ></VerInforme>
      <CargaRemito
        :visible="showCarga"
        :remito="editedItem.remito"
        :proveedor="this.proveedor"
        :flag="this.flag"
        @close="showCarga = false"
      ></CargaRemito>
    </v-app>
  </div>
</template>

<script>
import axios from "../../../src/axios-auth";
import VerInforme from "../Obras/Informerecepmaterial.vue";
// import EditarInforme from "../Obras/RecepMatRemito.vue";
import CargaRemito from "../Obras/CargaRemito.vue";

export default {
  // components: { VerInforme, EditarInforme },
  data: (vm) => ({
    showCarga: false,
    flag: "",
    remito: "",
    proveedor: "",
    editedItem: {},
    editedIndex: -1,
    comboobra: "",
    obras: [],
    listadoObras: [],
    listadoremitos: [],
    obrasactivas: true,
    headers: [
      {
        text: "Obra",
        align: "start",
        sortable: false,
        value: "obra",
      },
      { text: "Remito/Nota envío de ICSSA", value: "remito" },
      { text: "Fecha", value: "fecha" },
      { text: "Remito Recepción", value: "codgral" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    showInforme: false,
    showEditarInforme: false,
  }),

  computed: {
    show: {
      get() {
        this.cargarObras(true);
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          //this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  components: { CargaRemito, VerInforme },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    verInforme(item) {
      this.editedIndex = this.listadoObras.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showInforme = true;
    },
    editarInforme(item) {
      this.editedIndex = this.listadoObras.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarInforme = true;
    },
    cargarObras(valor) {
      let self = this;
      if (valor == true) {
        axios
          .get("/Obras/GetObras", {
            params: {
              estado: "P",
              filtro: "",
            },
          })
          .then((response) => {
            self.obras = response.data;
          })
          .catch((error) => {
            self.obras = [];
          });
      } else {
        axios
          .get("/Obras/GetObras", {
            params: {
              estado: "",
              filtro: "",
            },
          })
          .then((response) => {
            self.obras = response.data;
          })
          .catch((error) => {
            self.obras = [];
          });
      }
    },

    cargarListado() {
      const codigoobra = this.comboobra.gasto;
      if (codigoobra != null) {
        let self = this;
        axios
          .get("/Obras/ListadoRecepRemitoicssa?", {
            params: {
              codigo: codigoobra,
            },
          })
          .then((response) => {
            self.listadoremitos = response.data;
          })
          .catch((error) => {
            self.listadoremitos = [];
            console.log(error);
          });
      }
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },

    cargarRemito(item, codproveedor, bandera) {
      this.editedIndex = this.listadoObras.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.proveedor = codproveedor;
      this.flag = bandera;
      this.showCarga = true;
    },
    cerrarVentanaModificar() {
      this.showInforme = false;
      this.showEditarInforme = false;
      this.cargarListadoCompleto();
    },
  },
};
</script>
